// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BlogCommonPage.module.css */
.BlogsCommonPage_container__TAUEJ {
  min-height: 100vh;
  background-color: #000;
  padding: 2rem 1rem;
}

.BlogsCommonPage_article__oA1d1 {
  max-width: 1200px;
  margin: 6rem auto 1rem auto;
  background-color: #18181B;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.BlogsCommonPage_header__Gglfk {
  padding: 1rem 2rem 1.5rem;
}

.BlogsCommonPage_meta__cO9lQ {
  margin-bottom: 1rem;
}

.BlogsCommonPage_date__nyfk6 {
  color: #E50914;
  font-size: 0.875rem;
}

.BlogsCommonPage_title__A11jJ {
  font-size: 2.5rem;
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  letter-spacing: -0.025em;
}

.BlogsCommonPage_authorSection__2Rb0L {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: space-between;
}

.BlogsCommonPage_authorAvatar__Ob6C1 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #E50914;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 600;
}

.BlogsCommonPage_authorInfo__dcERk {
  display: flex;
  flex-direction: column;
  row-gap: 0.30rem;
}

.BlogsCommonPage_authorName__4Fja5 {
  font-weight: 600;
  color: #fff;
}
.BlogsCommonPage_authorviewContainer__SiA6u{
  display: flex;
  gap: 1.2rem;
}

.BlogsCommonPage_readTime__yLB01 {
  color: #6b7280;
  font-size: 0.875rem;
}

.BlogsCommonPage_featuredImage__w1Pp0 {
  margin: 0;
  width: 100%;
  height: auto;
  max-height: 500px;
  overflow: hidden;
}

.BlogsCommonPage_featuredImage__w1Pp0 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.BlogsCommonPage_content__56nCX {
  padding: 2rem;
  font-size: 1.125rem;
  line-height: 1.8;
  color: #fff;
}

.BlogsCommonPage_content__56nCX p {
  margin-bottom: 1.5rem;
}

.BlogsCommonPage_content__56nCX h2 {
  font-size: 1.875rem;
  font-weight: 700;
  margin: 2rem 0 1rem;
  color: white;
}

.BlogsCommonPage_content__56nCX h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 1.5rem 0 1rem;
  color: #1a1a1a;
}

.BlogsCommonPage_footer__D5i7d {
  padding: 1.5rem 2rem;
  border-top: 1px solid #e5e7eb;
}

.BlogsCommonPage_metrics__BnTvq {
  display: flex;
  gap: 1rem;
}

.BlogsCommonPage_metric__JBXQ5 {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #6b7280;
}

.BlogsCommonPage_icon__RdHvy {
  width: 1.25rem;
  height: 1.25rem;
}

.BlogsCommonPage_loadingSpinner__fxFqQ,
.BlogsCommonPage_errorMessage__W-F4b,
.BlogsCommonPage_notFound__TOS5Z {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  text-align: center;
}

.BlogsCommonPage_spinner__tgrgE {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: BlogsCommonPage_spin__al6MX 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes BlogsCommonPage_spin__al6MX {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.BlogsCommonPage_content__56nCX img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 2rem auto;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* For medium-sized images */
.BlogsCommonPage_content__56nCX img[width="500"],
.BlogsCommonPage_content__56nCX img[width="600"] {
  max-width: 600px;
  width: 100%;
}

/* For smaller images that shouldn't stretch */
.BlogsCommonPage_content__56nCX img[width="300"],
.BlogsCommonPage_content__56nCX img[width="400"] {
  max-width: 400px;
  width: 100%;
}

/* Responsive adjustments for images */
@media (max-width: 768px) {
  .BlogsCommonPage_content__56nCX img {
    margin: 1.5rem auto;
  }
}

/* Optional: Add figure and caption styling if your blog content includes them */
.BlogsCommonPage_content__56nCX figure {
  margin: 2rem auto;
  max-width: 100%;
}

.BlogsCommonPage_content__56nCX figure img {
  margin: 0 auto 0.5rem;
}

.BlogsCommonPage_content__56nCX figcaption {
  text-align: center;
  font-size: 0.875rem;
  color: #9ca3af;
  margin-top: 0.5rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .BlogsCommonPage_container__TAUEJ {
    padding: 1rem 0;
  }

  .BlogsCommonPage_article__oA1d1 {
    border-radius: 0;
  }

  .BlogsCommonPage_header__Gglfk {
    padding: 0.5rem 1rem;
  }

  .BlogsCommonPage_title__A11jJ {
    font-size: 2rem;
  }

  .BlogsCommonPage_content__56nCX {
    padding: 1.5rem 1rem;
    font-size: 1rem;
  }

  .BlogsCommonPage_footer__D5i7d {
    padding: 1rem;
  }
  .BlogsCommonPage_authorSection__2Rb0L{
    margin-bottom: 0.7rem;
  }
}

@media (max-width: 480px) {
  .BlogsCommonPage_title__A11jJ {
    font-size: 1.75rem;
  }

  .BlogsCommonPage_authorSection__2Rb0L {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.7rem;
  }

  .BlogsCommonPage_metrics__BnTvq {
    justify-content: space-around;
  }

  .BlogsCommonPage_meta__cO9lQ {
    margin-left: 0.3rem;
    margin-bottom: 0.1rem;
  }
}


/* Add these styles to your existing BlogsCommonPage.module.css file */

/* Similar Blogs Section */
.BlogsCommonPage_similarBlogsSection__9vz7S {
  padding: 2rem;
  border-top: 1px solid #27272A;
  margin-top: 2rem;
}

.BlogsCommonPage_similarBlogsTitle__yCLus {
  font-size: 1.75rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 1.5rem;
  text-align: center;
}

.BlogsCommonPage_similarBlogsGrid__68FeP {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.BlogsCommonPage_similarBlogCard__ziAq4 {
  background-color: #27272A;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.BlogsCommonPage_similarBlogCard__ziAq4:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2);
}

.BlogsCommonPage_similarBlogImage__UzhqF {
  height: 180px;
  overflow: hidden;
}

.BlogsCommonPage_similarBlogImage__UzhqF img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.BlogsCommonPage_similarBlogCard__ziAq4:hover .BlogsCommonPage_similarBlogImage__UzhqF img {
  transform: scale(1.05);
}

.BlogsCommonPage_similarBlogContent__pMEyz {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.BlogsCommonPage_similarBlogTitle__KOWFW {
  font-size: 1.125rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 0.5rem;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.BlogsCommonPage_similarBlogMeta__2ZaMM {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.BlogsCommonPage_similarBlogCategory__JetEL {
  font-size: 0.75rem;
  color: #E50914;
  background-color: rgba(229, 9, 20, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-weight: 500;
}

.BlogsCommonPage_similarBlogStats__VA48\\+ {
  display: flex;
  gap: 0.75rem;
}

.BlogsCommonPage_similarBlogViews__Hbzax {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #9CA3AF;
  font-size: 0.75rem;
}

.BlogsCommonPage_smallIcon__DrxUR {
  width: 0.875rem;
  height: 0.875rem;
}

.BlogsCommonPage_similarBlogExcerpt__2Nar4 {
  font-size: 0.875rem;
  color: #D1D5DB;
  margin-top: 0.5rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 1.5;
}

.BlogsCommonPage_similarBlogsLoading__0WwKT {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.BlogsCommonPage_smallSpinner__NpnUX {
  width: 30px;
  height: 30px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #E50914;
  border-radius: 50%;
  animation: BlogsCommonPage_spin__al6MX 1s linear infinite;
}

.BlogsCommonPage_noSimilarBlogs__-2GLP {
  text-align: center;
  padding: 2rem;
  color: #9CA3AF;
  font-style: italic;
}

/* Media Queries for Similar Blogs Section */
@media (max-width: 768px) {
  .BlogsCommonPage_similarBlogsSection__9vz7S {
    padding: 1.5rem 1rem;
  }
  
  .BlogsCommonPage_similarBlogsGrid__68FeP {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .BlogsCommonPage_similarBlogsGrid__68FeP {
    grid-template-columns: 1fr;
  }
  
  .BlogsCommonPage_similarBlogsTitle__yCLus {
    font-size: 1.5rem;
  }
  
  .BlogsCommonPage_similarBlogImage__UzhqF {
    height: 160px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Blogs/Components/CSS/BlogsCommonPage.module.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,yDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA,8CAA8C;AAC9C;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,gFAAgF;AAChF;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;;AAGA,sEAAsE;;AAEtE,0BAA0B;AAC1B;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,qDAAqD;EACrD,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,yDAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* BlogCommonPage.module.css */\n.container {\n  min-height: 100vh;\n  background-color: #000;\n  padding: 2rem 1rem;\n}\n\n.article {\n  max-width: 1200px;\n  margin: 6rem auto 1rem auto;\n  background-color: #18181B;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.header {\n  padding: 1rem 2rem 1.5rem;\n}\n\n.meta {\n  margin-bottom: 1rem;\n}\n\n.date {\n  color: #E50914;\n  font-size: 0.875rem;\n}\n\n.title {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: #fff;\n  line-height: 1.2;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.025em;\n}\n\n.authorSection {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  justify-content: space-between;\n}\n\n.authorAvatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: #E50914;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.authorInfo {\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.30rem;\n}\n\n.authorName {\n  font-weight: 600;\n  color: #fff;\n}\n.authorviewContainer{\n  display: flex;\n  gap: 1.2rem;\n}\n\n.readTime {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.featuredImage {\n  margin: 0;\n  width: 100%;\n  height: auto;\n  max-height: 500px;\n  overflow: hidden;\n}\n\n.featuredImage img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.content {\n  padding: 2rem;\n  font-size: 1.125rem;\n  line-height: 1.8;\n  color: #fff;\n}\n\n.content p {\n  margin-bottom: 1.5rem;\n}\n\n.content h2 {\n  font-size: 1.875rem;\n  font-weight: 700;\n  margin: 2rem 0 1rem;\n  color: white;\n}\n\n.content h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 1.5rem 0 1rem;\n  color: #1a1a1a;\n}\n\n.footer {\n  padding: 1.5rem 2rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.metrics {\n  display: flex;\n  gap: 1rem;\n}\n\n.metric {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: #6b7280;\n}\n\n.icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.loadingSpinner,\n.errorMessage,\n.notFound {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  text-align: center;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.content img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 2rem auto;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* For medium-sized images */\n.content img[width=\"500\"],\n.content img[width=\"600\"] {\n  max-width: 600px;\n  width: 100%;\n}\n\n/* For smaller images that shouldn't stretch */\n.content img[width=\"300\"],\n.content img[width=\"400\"] {\n  max-width: 400px;\n  width: 100%;\n}\n\n/* Responsive adjustments for images */\n@media (max-width: 768px) {\n  .content img {\n    margin: 1.5rem auto;\n  }\n}\n\n/* Optional: Add figure and caption styling if your blog content includes them */\n.content figure {\n  margin: 2rem auto;\n  max-width: 100%;\n}\n\n.content figure img {\n  margin: 0 auto 0.5rem;\n}\n\n.content figcaption {\n  text-align: center;\n  font-size: 0.875rem;\n  color: #9ca3af;\n  margin-top: 0.5rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 1rem 0;\n  }\n\n  .article {\n    border-radius: 0;\n  }\n\n  .header {\n    padding: 0.5rem 1rem;\n  }\n\n  .title {\n    font-size: 2rem;\n  }\n\n  .content {\n    padding: 1.5rem 1rem;\n    font-size: 1rem;\n  }\n\n  .footer {\n    padding: 1rem;\n  }\n  .authorSection{\n    margin-bottom: 0.7rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .title {\n    font-size: 1.75rem;\n  }\n\n  .authorSection {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.7rem;\n  }\n\n  .metrics {\n    justify-content: space-around;\n  }\n\n  .meta {\n    margin-left: 0.3rem;\n    margin-bottom: 0.1rem;\n  }\n}\n\n\n/* Add these styles to your existing BlogsCommonPage.module.css file */\n\n/* Similar Blogs Section */\n.similarBlogsSection {\n  padding: 2rem;\n  border-top: 1px solid #27272A;\n  margin-top: 2rem;\n}\n\n.similarBlogsTitle {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.similarBlogsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.similarBlogCard {\n  background-color: #27272A;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.similarBlogCard:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2);\n}\n\n.similarBlogImage {\n  height: 180px;\n  overflow: hidden;\n}\n\n.similarBlogImage img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.similarBlogCard:hover .similarBlogImage img {\n  transform: scale(1.05);\n}\n\n.similarBlogContent {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.similarBlogTitle {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 0.5rem;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.similarBlogMeta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.similarBlogCategory {\n  font-size: 0.75rem;\n  color: #E50914;\n  background-color: rgba(229, 9, 20, 0.1);\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.similarBlogStats {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.similarBlogViews {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: #9CA3AF;\n  font-size: 0.75rem;\n}\n\n.smallIcon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n.similarBlogExcerpt {\n  font-size: 0.875rem;\n  color: #D1D5DB;\n  margin-top: 0.5rem;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  line-height: 1.5;\n}\n\n.similarBlogsLoading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.smallSpinner {\n  width: 30px;\n  height: 30px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #E50914;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.noSimilarBlogs {\n  text-align: center;\n  padding: 2rem;\n  color: #9CA3AF;\n  font-style: italic;\n}\n\n/* Media Queries for Similar Blogs Section */\n@media (max-width: 768px) {\n  .similarBlogsSection {\n    padding: 1.5rem 1rem;\n  }\n  \n  .similarBlogsGrid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .similarBlogsGrid {\n    grid-template-columns: 1fr;\n  }\n  \n  .similarBlogsTitle {\n    font-size: 1.5rem;\n  }\n  \n  .similarBlogImage {\n    height: 160px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BlogsCommonPage_container__TAUEJ`,
	"article": `BlogsCommonPage_article__oA1d1`,
	"header": `BlogsCommonPage_header__Gglfk`,
	"meta": `BlogsCommonPage_meta__cO9lQ`,
	"date": `BlogsCommonPage_date__nyfk6`,
	"title": `BlogsCommonPage_title__A11jJ`,
	"authorSection": `BlogsCommonPage_authorSection__2Rb0L`,
	"authorAvatar": `BlogsCommonPage_authorAvatar__Ob6C1`,
	"authorInfo": `BlogsCommonPage_authorInfo__dcERk`,
	"authorName": `BlogsCommonPage_authorName__4Fja5`,
	"authorviewContainer": `BlogsCommonPage_authorviewContainer__SiA6u`,
	"readTime": `BlogsCommonPage_readTime__yLB01`,
	"featuredImage": `BlogsCommonPage_featuredImage__w1Pp0`,
	"content": `BlogsCommonPage_content__56nCX`,
	"footer": `BlogsCommonPage_footer__D5i7d`,
	"metrics": `BlogsCommonPage_metrics__BnTvq`,
	"metric": `BlogsCommonPage_metric__JBXQ5`,
	"icon": `BlogsCommonPage_icon__RdHvy`,
	"loadingSpinner": `BlogsCommonPage_loadingSpinner__fxFqQ`,
	"errorMessage": `BlogsCommonPage_errorMessage__W-F4b`,
	"notFound": `BlogsCommonPage_notFound__TOS5Z`,
	"spinner": `BlogsCommonPage_spinner__tgrgE`,
	"spin": `BlogsCommonPage_spin__al6MX`,
	"similarBlogsSection": `BlogsCommonPage_similarBlogsSection__9vz7S`,
	"similarBlogsTitle": `BlogsCommonPage_similarBlogsTitle__yCLus`,
	"similarBlogsGrid": `BlogsCommonPage_similarBlogsGrid__68FeP`,
	"similarBlogCard": `BlogsCommonPage_similarBlogCard__ziAq4`,
	"similarBlogImage": `BlogsCommonPage_similarBlogImage__UzhqF`,
	"similarBlogContent": `BlogsCommonPage_similarBlogContent__pMEyz`,
	"similarBlogTitle": `BlogsCommonPage_similarBlogTitle__KOWFW`,
	"similarBlogMeta": `BlogsCommonPage_similarBlogMeta__2ZaMM`,
	"similarBlogCategory": `BlogsCommonPage_similarBlogCategory__JetEL`,
	"similarBlogStats": `BlogsCommonPage_similarBlogStats__VA48+`,
	"similarBlogViews": `BlogsCommonPage_similarBlogViews__Hbzax`,
	"smallIcon": `BlogsCommonPage_smallIcon__DrxUR`,
	"similarBlogExcerpt": `BlogsCommonPage_similarBlogExcerpt__2Nar4`,
	"similarBlogsLoading": `BlogsCommonPage_similarBlogsLoading__0WwKT`,
	"smallSpinner": `BlogsCommonPage_smallSpinner__NpnUX`,
	"noSimilarBlogs": `BlogsCommonPage_noSimilarBlogs__-2GLP`
};
export default ___CSS_LOADER_EXPORT___;
